import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => (
  <footer className="bg-midnight text-white" data-testid="site-footer">
    <div className="bg-blueprint-dark">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 md:grid-cols-3 lg:px-8">
        <div>
          <div className="flex items-center gap-3">
            <span className="grid h-9 w-9 grid-cols-2 grid-rows-2">
              <span className="bg-white" />
              <span className="bg-ciel" />
              <span className="bg-terrain" />
              <span className="bg-qualite" />
            </span>
            <span className="font-display text-xl font-extrabold tracking-tight">
              ATLAS <span className="text-ciel">THD</span>
            </span>
          </div>
          <p className="mt-4 font-display text-sm font-bold tracking-[0.2em] text-terrain">
            CONNECTER. CONTRÔLER. FIABILISER.
          </p>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/60">
            Raccordement fibre optique, inspection technique et contrôle qualité
            pour les acteurs des télécommunications — avec rigueur, fiabilité et
            maîtrise du terrain.
          </p>
        </div>
        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white/50">
            Navigation
          </h3>
          <ul className="mt-4 space-y-3 text-sm">
            <li><Link to="/" data-testid="footer-nav-accueil" className="text-white/80 transition-colors hover:text-white">Accueil</Link></li>
            <li><Link to="/terrain-fibre" data-testid="footer-nav-terrain" className="text-white/80 transition-colors hover:text-white">Raccordement fibre FTTO / FTTH</Link></li>
            <li><Link to="/qualite-controle" data-testid="footer-nav-qualite" className="text-white/80 transition-colors hover:text-white">Inspection &amp; contrôle qualité</Link></li>
            <li><Link to="/sous-traitance-fibre-optique" data-testid="footer-nav-soustraitance" className="text-white/80 transition-colors hover:text-white">Sous-traitance fibre optique</Link></li>
            <li><Link to="/raccordement-ftth-d3" data-testid="footer-nav-ftthd3" className="text-white/80 transition-colors hover:text-white">Raccordement FTTH D3</Link></li>
            <li><Link to="/zones-intervention" data-testid="footer-nav-zones" className="text-white/80 transition-colors hover:text-white">Zones d'intervention</Link></li>
            <li><Link to="/realisations" data-testid="footer-nav-realisations" className="text-white/80 transition-colors hover:text-white">Réalisations</Link></li>
            <li><Link to="/guides" data-testid="footer-nav-guides" className="text-white/80 transition-colors hover:text-white">Guides</Link></li>
            <li><Link to="/faq" data-testid="footer-nav-faq" className="text-white/80 transition-colors hover:text-white">FAQ</Link></li>
            <li><Link to="/contact" data-testid="footer-nav-contact" className="text-white/80 transition-colors hover:text-white">Contact</Link></li>
          </ul>
        </div>
        <div>
          <h3 className="font-display text-sm font-bold uppercase tracking-[0.2em] text-white/50">
            Contact
          </h3>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <a href="tel:+33605765066" data-testid="footer-phone" className="flex items-center gap-3 text-white/80 transition-colors hover:text-white">
                <Phone className="h-4 w-4 text-terrain" />
                06 05 76 50 66
              </a>
            </li>
            <li>
              <a href="mailto:Contact.pro@atlasthd.com" data-testid="footer-email" className="flex items-center gap-3 text-white/80 transition-colors hover:text-white">
                <Mail className="h-4 w-4 text-terrain" />
                Contact.pro@atlasthd.com
              </a>
            </li>
            <li className="flex items-center gap-3 text-white/80">
              <MapPin className="h-4 w-4 text-terrain" />
              Interventions sur toute la France
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-2 px-4 py-6 text-xs text-white/40 sm:px-6 md:flex-row lg:px-8">
          <span>© {new Date().getFullYear()} ATLAS THD — Tous droits réservés</span>
          <span className="flex items-center gap-4">
            <Link to="/mentions-legales" data-testid="footer-mentions-legales" className="transition-colors hover:text-white">Mentions légales</Link>
            <Link to="/politique-confidentialite" data-testid="footer-politique-confidentialite" className="transition-colors hover:text-white">Politique de confidentialité</Link>
          </span>
          <span className="font-display tracking-[0.15em]">CONNECTER. CONTRÔLER. FIABILISER.</span>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
